import { atom } from "recoil"

export const contactDetailRequestIdState = atom<number>({
  key: "atoms/contact/contactDetailRequestIdState",
  default: 0,
})
